import React, { useCallback, useEffect, useState } from "react";
import MdmCard from "../../components/mdmCard/MdmCard";
import "./mdm.css";
import { getMDMConfiguration, getMasterData } from "../../services/mdmService/mdmService";
import { DomainValue} from "../../services/mdmService/types";
import MdmCardMenu from "../../components/mdmCardMenu/MdmCardMenu";
import { ConfirmationPopUp } from "../../components/popup/confirmationPopUp";
import { useNavigate } from "react-router-dom";
import { setCurrentEntity } from "../../stateManagement/actions/mdmActions";
import ImportMdmDataModal from "../../components/importModal/importMdmDataModal";
import { mdmRegistryObj } from "./mdmRegistry";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";
import { eventEnum, logEvent } from "../../services/eventsService/eventService";
import { fetchAndDownloadReport } from "../../services/reportService";
function Mdm() {
  const { translate } = usePortalTranslation();
  const CUR_COMPONENT_COMMON="commonPortal";
  const CUR_COMPONENT = "Master Data Management"
  const [showModal, setShowModal] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [mdmData, setMdmData] = useState<DomainValue[]>([]);
  const [popoverAnchorElement, setPopoverAnchorElement] = React.useState<null | HTMLElement>(null);
  const [menuMoreOption, setMenuMoreOption] = useState<DomainValue|null>(null)
  const [confirmationModalOpened, setConfirmationModalOpened] = useState(false);
  const [downloadUrl, setDownloadUrl] = useState<string|undefined>("");
  const navigate = useNavigate();
  const mdmDataConfig = useCallback(async () => {
    const response = await getMDMConfiguration();
    if(response.length === 0) setShowErrorMessage(true);
    logEvent(eventEnum.integration_plugin,{feature_name:"MDM"})
    setMdmData(response);
  }, []);
  useEffect(() => {
    mdmDataConfig();
  }, [mdmDataConfig]);
  const open = Boolean(popoverAnchorElement)
  const changePopoverAnchorElement = (event: React.MouseEvent<HTMLElement|null>) => {
    event.stopPropagation();
    if(popoverAnchorElement===event.currentTarget){
      setPopoverAnchorElement(null);
    }
    else{
      const menuId = event.currentTarget.id;
      const findMenu:DomainValue|undefined = mdmData.find((obj:DomainValue)=> obj&&obj.id === menuId);
      if(findMenu){
        setMenuMoreOption(findMenu);
        setPopoverAnchorElement(event.currentTarget);
      }
    }
  };
  const closeMoreOptionPopover =()=>{
    setPopoverAnchorElement(null);
  }
  const mdmMenuRegistry = ( event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement> )=> {
    if(menuMoreOption !== null){
        setCurrentEntity(menuMoreOption as mdmRegistryObj);     
        if(menuMoreOption.id === "Variable"){
          if(event.currentTarget.id === "viewsAndEdit"){
            navigate("/dashboard/mdm/division")
            return;
          }
        }   
        switch (event.currentTarget.id) {
          case "import":
            mdmData.forEach((element)=>{
              if(element.id === menuMoreOption.id){
                setDownloadUrl(element.templateUrl);
              }
            });
            setShowModal(true)
            break;
          case "viewsAndEditDivision":
            navigate("roleDivision")
            break;
          case "logsAndReport":
            navigate("logs")
            break;
          case "viewsAndEdit":
            navigate("viewAndEdit")
            break;
          case "masterDownload":
            setConfirmationModalOpened(true);
            break;
          case "dataSupportDownload":
            navigate("dataValidationSupport");
            break;
          default:
            break;
        }
    }
  }
  const downloadFile = async ()=>{
    
    const url = await getMasterData(menuMoreOption?.id);
    
    fetchAndDownloadReport(url);
  }
  return (
    <>
     { showErrorMessage ?<div className="mdm-error">
         <div className="mdm-card-error-msz"> Cards are not available for Now, Kindly refresh</div>
        </div> :
         <>
        <div className="mdm-body" onClick={closeMoreOptionPopover}>
          <div className="mdm-title">{translate(TranslationEnum.common_portal,"Master Data Management")}</div>
          <div className="mdm-container" >
            { mdmData.length > 0 && mdmData.map((mdmDataObject: DomainValue, colorIndex:number) => {
              const mdmDataObj = {...mdmDataObject}
              return <MdmCard colorIndex={colorIndex} key={mdmDataObj.id} mdmData={mdmDataObj}  changePopoverAnchorElement={changePopoverAnchorElement}/>;
            })}
            <MdmCardMenu menuMoreOption={menuMoreOption}  id="simple-popper" open={open} popoverAnchorElement={popoverAnchorElement}  mdmMenuRegistry={mdmMenuRegistry}/>
          </div>
        </div>
        <ImportMdmDataModal Open={showModal} setShowModal={setShowModal} downloadUrl={downloadUrl}/>
        <>
          <ConfirmationPopUp
            message="Are you sure you want to download master data?"
            openConfirmModal={confirmationModalOpened}
            setOpenConfirmModal={setConfirmationModalOpened}
            successMethod={downloadFile}
          />
        </> 
      </> 
      }
    </>
  );
}

export default Mdm;
